<formio-loader></formio-loader>
<div class="dialog-title">
    <h1 mat-dialog-title class="custom-title">
        <span *ngIf="data.isAdd;else edit">{{'forms.common.Add' | translate}} {{ 'forms.common.' + data.name |
            translate}}
        </span>
        <ng-template #edit>
            <span *ngIf="data.isAdd == false">{{'forms.common.Edit' | translate}} {{ 'forms.common.' + data.name | translate}}</span>
            <span *ngIf="data.isView">{{'forms.common.View' | translate}} {{ 'forms.common.' + data.name | translate}}</span>
        </ng-template>
    </h1>
</div>
<form [formGroup]="formControls" id="dialog-form">
    <div mat-dialog-content class="custom-border">
        <div class="row" [dir]="data.dir">
            <div class="col-sm-6" *ngFor="let item of data.fields;let i=index">

                <div [ngSwitch]="item.type">
                    <mat-form-field *ngSwitchCase="ENUM_FIELD_TYPE.INPUT" class="example-full-width" appearance="standard" floatLabel="always">
                        <mat-label>{{ 'forms.common.' + item.name | translate}}</mat-label>
                        <input matInput type="{{item.type}}" id="{{item.name}}" name="{{item.name}}" formControlName="{{item.name}}" [value]="item?.value?item.value:''" pattern="{{item?.pattern}}" (input)="onInputChanged(item, $event)  ">
                        <span *ngIf="formControls.controls[item.name].errors && formControls.controls[item.name].touched">
                            <mat-error>{{ 'forms.common.' + item.name | translate}}&nbsp;</mat-error>
                            <mat-error *ngIf="formControls.controls[item.name].errors.required">{{'forms.common.It can not be empty' | translate}}</mat-error>
                            <mat-error *ngIf="formControls.controls[item.name].errors.min">{{'forms.common.It must be greater or equal to' | translate}} {{formControls.controls[item.name].errors.min.min}}
                            </mat-error>
                            <mat-error *ngIf="formControls.controls[item.name].errors.max">{{'forms.common.It must be less than or equal to' | translate}} {{formControls.controls[item.name].errors.max.max}}
                            </mat-error>
                            <mat-error *ngIf="formControls.controls[item.name].errors.pattern">{{'forms.common.contains an invalid value' | translate}}</mat-error>
                        </span>
                    </mat-form-field>

                    <mat-form-field *ngSwitchCase="ENUM_FIELD_TYPE.SELECT" appearance="outline">
                        <mat-label>{{ 'forms.common.' + item.name | translate}}</mat-label>
                        <mat-select disableOptionCentering formControlName="{{item.name}}" [(ngModel)]="item.selectedItems" multiple>
                            <mat-option [value]="ele" *ngFor="let ele of item?.dataSource">{{ele.data.key}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div *ngSwitchDefault>ngSwitchDefault</div>
                </div>


            </div>
        </div>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-flat-button (click)="onNoClick()"  >{{ 'forms.common.Cancel' |
            translate}}</button>
        <button mat-button type="submit" *ngIf="!data.isView" class="dialog-button dialog-save" [disabled]="formControls.invalid" color="primary" (click)="onSaveResource()">{{ 'forms.common.Save' | translate}}</button>
    </div>
    <!-- [mat-dialog-close]="data" -->
</form>